/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
// 接口返回全局状态码
export const RESPONSE_CODE = {
  SUCCESS: 200, // 接口调用成功
  TOKEN_OVERDUE: 401, // token 失效，登录过期
  NO_PERMISSION: 403, // 无访问资源权限
  TOKEN_ERROR: 1005, // token 无效
  OTHER_LOGIN: 1006, // 账号被其他人登录
  ACCOUNT_FORBIDDEN: 1007, // 账号被禁用
  LOGIN_PSW_NAME_ERROR: 1000, // 登录名或密码错误
}

export const ENTRANCE_TYPE = {
  UNKNOW: 0,

  /** 首页中插 */
  HOME_PAGE_INSERTION: 1,

  /** 首页弹窗 */
  HOME_PAGE_POPUP: 2,

  /** 开屏 */

  THE_TAIL: 3,

  /** 顶部推荐 */

  TOP_RECOMMENDATIONS: 4,

  /** 首页列表 */

  HOME_PAGE_LIST: 5,

  /** 产品列表 */

  LIST_OF_PRODUCTS: 6,

  /** 随机推荐 */

  RANDOM_RECOMMENDATION: 7,

  /** 路由码入口 */
  ROUTE_CODE: 8
} as const

/**
 * 公司主体及备案号
 */
export const CompanyType = {

  /** 虫洞跳跃信息 */

  YQQB_COMPANY: {
    company: '广州虫洞跳跃信息科技有限公司',
    recordNumber: '粤ICP备2022120631号'
  },

  /** 中安信业信息 */

  ZAXY_COMPANY: {
    company: '深圳市中安信业小额贷款有限公司',
    recordNumber: '粤ICP备16075822号'
  },

  /** 魅塔信息 */
  META_COMPANY: {
    company: '深圳市中安信业小额贷款有限公司',
    recordNumber: '粤ICP备16075822号-1'
  },

  /** 湘江源信息 */
  XJY_COMPANY: {
    company: '全州县湘江源小额贷款有限公司',
    recordNumber: '桂ICP备2023008904号-1'
  },

  /** 虫洞穿越信息 */
  CDCY_COMPANY: {
    company: '广州虫洞跳跃信息科技有限公司',
    recordNumber: '粤ICP备2025402086号'
  },
}

/**
 * 请求拦截器携带埋点参数
 */
export enum InterceptorParams {

  /** 快手 */
  KS_PARAMS = 2,

  /** 百度 */
  BD_PARAMS = 3,

  /** Soul */
  SOUL_PARAMS = 4
}

/** 分期乐机型字段 */
export enum FqlPhoneModel { //
  /** 苹果 */
  iphone = '01', //
  /** 华为 */
  HuaWei = '02', //
  /** 荣耀 */
  RongYao = '03', //
  /** oppo */
  oppo = '04', //
  /** vivo */
  vivo = '05', //
  /** 小米 */
  XiaoMi = '06', //
  /** 三星 */
  Samsung = '07', //
  /** 1+ */
  One = '08', //
  /** 其他 */
  Other = '09',
}

/** 结果页展示 */
export enum PageSetup {
  /** 仅展示分发结果，无H5和下载 */
  OnlyShowDistributionResults = 1,
  /** 结果页有后端变现和下载功能 */
  ResultPageWithH5AndDownload = 0,
}

/** 上传文件夹 */
export const OSS_DIR = {
  CRM_IDCARD: 'CRM_IDCARD',
} as const

/** OSS 上传文件夹的 key 类型 */
export type OSS_DIR_KEY_TYPE = keyof typeof OSS_DIR

/** OSS 上传文件夹的值类型 */
export type OSS_DIR_VALUE_TYPE = typeof OSS_DIR[OSS_DIR_KEY_TYPE]

/** 文件上传 oss 文件夹名称 */
export const OSS_DIR_NAME: Record<OSS_DIR_VALUE_TYPE, string> = {
  [OSS_DIR.CRM_IDCARD]: '下游-法人身份证正反面',
}


/** OSS静态资源路径 */
export const OSS_URLS = ''

/** intercom appid */
export const INTERCOM_APP_ID = ''

/** 
 * 个人信息授权协议Type
 * 如果协议type返回为1或者19，则将其设置为默认协议
 * 1对应有钱来默认协
 * 19对应广进客默认协议
 * 21对应乐小花
 */
export const AgreementType = [1, 19, 21]
